import styled from 'styled-components';
import { ButtonStyledProps } from '../Button.types';

const Button = styled.button<ButtonStyledProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ inline }) => (inline === true ? 'auto' : '100%')};
  font-size: ${({ theme }) => theme.typography.fontSizes['B14']};
  line-height: ${({ theme }) => theme.typography.lineHeights['M24']};
  border-width: 1px 0;
  border-style: solid;
  border-color: transparent;
  color: #666;
  cursor: pointer;

  &:hover,
  &:focus {
    &:not(:disabled) {
      border-bottom-color: #666;
    }
  }

  &:disabled {
    color: #999;
    cursor: not-allowed;
  }
`;

const Leading = styled.div`
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  height: 100%;
  line-height: 0;
  overflow: hidden;
  padding-right: 4px;

  ${Button}:disabled & {
    color: #d9d9d9;
  }
`;

const Trailing = styled.div`
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  height: 100%;
  line-height: 0;
  overflow: hidden;
  padding-left: 4px;

  ${Button}:disabled & {
    color: #d9d9d9;
  }
`;

export { Button, Leading, Trailing };
